module.exports = __webpack_public_path__ + "img/stamp.b9f5db62.svg";